// export const data = [
//   {
//     category: "Facility Types",
//     fields: [
//       { type: "checkbox", label: "Short Term Acute Care" },
//       { type: "checkbox", label: "Children Hospital" },
//       { type: "checkbox", label: "Psychiatric Hospital" },
//       { type: "checkbox", label: "Long Term Hospital" },
//       { type: "checkbox", label: "Rehabilitation Hospital" },
//       { type: "checkbox", label: "Critical Access Care" },
//     ],
//   },
//   {
//     category: "Ownership Types",
//     fields: [
//       { type: "checkbox", label: "Voluntary Nonprofit, Other" },
//       { type: "checkbox", label: "Voluntary Nonprofit, Church" },
//       { type: "checkbox", label: "Governmental, City" },
//       { type: "checkbox", label: "Governmental, State" },
//       { type: "checkbox", label: "Governmental, Other" },
//       { type: "checkbox", label: "Proprietary, Partnership" },
//       { type: "checkbox", label: "Proprietary, Corporation" },
//       { type: "checkbox", label: "Governmental, Hospital District" },
//       { type: "checkbox", label: "Governmental, County" },
//       { type: "checkbox", label: "Proprietary, Individual" },
//       { type: "checkbox", label: "Proprietary, Other" },
//       { type: "checkbox", label: "Governmental, City-County" },
//       { type: "checkbox", label: "Governmental, Federal" },
//     ],
//   },
//   {
//     category: "Financial & Operational Metrics",
//     fields: [
//       { type: "checkbox", label: "Gross Revenue" },
//       { type: "checkbox", label: "Net Revenue" },
//       { type: "checkbox", label: "Net Patient Revenue" },
//       { type: "checkbox", label: "Operating Income" },
//       { type: "checkbox", label: "Total Operating Expenses" },
//       { type: "checkbox", label: "Net Income" },
//       { type: "checkbox", label: "Net Income Margin" },
//       { type: "checkbox", label: "Inparient Revenue" },
//       { type: "checkbox", label: "Outpatient Revenue" },
//     ],
//   },
//   {
//     category: "Oncology Focus - Procedure Volume (2023)",
//     fields: [
//       { type: "checkbox", label: "Radiation Therapy" },
//       { type: "checkbox", label: "Chemo Therapy" },
//       { type: "checkbox", label: "Surgical Oncology" },
//     ],
//   },
//   {
//     category: "Quality of care",
//     fields: [
//       { type: "checkbox", label: "Cleanliness" },
//       { type: "checkbox", label: "Doctor Communication" },
//       { type: "checkbox", label: "Care Transition" },
//       { type: "checkbox", label: "Discharge Information" },
//       { type: "checkbox", label: "Communication About Medicines" },
//       { type: "checkbox", label: "Nurse Communication" },
//       { type: "checkbox", label: "Overall Hospital Rating" },
//       { type: "checkbox", label: "Quietness" },
//       { type: "checkbox", label: "Recommend Hospital" },
//       { type: "checkbox", label: "Staff Responsiveness" },
//       { type: "checkbox", label: "Summary Star Rating" },
//     ],
//   },
//   {
//     category: "Cancer Incidence",
//     fields: [
//       { type: "checkbox", label: "Estimated case density in CBSA" },
//       { type: "checkbox", label: "Heart Attack Excess Readmission Ratio" },
//       { type: "checkbox", label: "Heart Failure Excess Readmission Ratio" },
//       { type: "checkbox", label: "CABG Excess Readmission Ratio" },
//       { type: "checkbox", label: "COPD Excess Readmission Ratio" },
//       {
//         type: "checkbox",
//         label: "Hip/Knee Replacement Excess Readmission Ratio",
//       },
//       { type: "checkbox", label: "Pneumonia Excess Readmission Ratio" },
//     ],
//   },
// ];

export const data = [
    {
      category: "Core Weightages",
      fields: [
        { type: "checkbox", label: "Beds Count" },
        { type: "checkbox", label: "Discharges Count" },
        { type: "checkbox", label: "Net Patient Revenue" },
        { type: "checkbox", label: "Overall Rating" },
      ],
    },
  ];

export const hospitalsList = [
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 721,
      "INPATIENT_REVENUE": "$3,07,11,59,808.00",
      "NET_PATIENT_REVENUE": "$4,90,03,79,136.00",
      "OUTPATIENT_REVENUE": "7860414976",
      "accreditation_count": 10,
      "city": "Houston",
      "coc_type": null,
      "hosp10_name": "University of Texas MD Anderson Cancer Center",
      "latitude": 29.707053,
      "longitude": -95.3971227,
      "prov_control_type": "Governmental - State",
      "provider_number": 4017,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 1137,
      "INPATIENT_REVENUE": "$7,45,25,27,104.00",
      "NET_PATIENT_REVENUE": "$2,98,77,85,472.00",
      "OUTPATIENT_REVENUE": "4194196736",
      "accreditation_count": 13,
      "city": "Houston",
      "coc_type": null,
      "hosp10_name": "Memorial Hermann - Texas Medical Center",
      "latitude": 29.714052,
      "longitude": -95.396173,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 4018,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 976,
      "INPATIENT_REVENUE": "$7,87,33,53,216.00",
      "NET_PATIENT_REVENUE": "$2,84,81,50,016.00",
      "OUTPATIENT_REVENUE": "6266345984",
      "accreditation_count": 14,
      "city": "Houston",
      "coc_type": null,
      "hosp10_name": "Houston Methodist Hospital (FKA the Methodist Hospital)",
      "latitude": 29.709033,
      "longitude": -95.400335,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 4012,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 905,
      "INPATIENT_REVENUE": "$4,02,34,15,552.00",
      "NET_PATIENT_REVENUE": "$2,84,21,23,264.00",
      "OUTPATIENT_REVENUE": "2987020288",
      "accreditation_count": 12,
      "city": "Houston",
      "coc_type": null,
      "hosp10_name": "Texas Childrens Hospital",
      "latitude": 29.708155,
      "longitude": -95.400365,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 6386,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 811,
      "INPATIENT_REVENUE": "$13,77,90,97,600.00",
      "NET_PATIENT_REVENUE": "$2,66,53,95,712.00",
      "OUTPATIENT_REVENUE": "6720537600",
      "accreditation_count": 7,
      "city": "San Antonio",
      "coc_type": null,
      "hosp10_name": "Methodist Hospital",
      "latitude": 29.507191,
      "longitude": -98.572298,
      "prov_control_type": "Proprietary - Partnership",
      "provider_number": 3862,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 737,
      "INPATIENT_REVENUE": "$2,83,73,23,776.00",
      "NET_PATIENT_REVENUE": "$2,28,04,52,864.00",
      "OUTPATIENT_REVENUE": "3710602496",
      "accreditation_count": 9,
      "city": "Dallas",
      "coc_type": null,
      "hosp10_name": "William P Clements Jr University Hospital (FKA UT Southwestern University Hospital - St Paul)",
      "latitude": 32.818643,
      "longitude": -96.848586,
      "prov_control_type": "Governmental - State",
      "provider_number": 3923,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 388,
      "INPATIENT_REVENUE": "$2,47,10,54,080.00",
      "NET_PATIENT_REVENUE": "$1,89,26,16,192.00",
      "OUTPATIENT_REVENUE": "1552134784",
      "accreditation_count": 11,
      "city": "Dallas",
      "coc_type": null,
      "hosp10_name": "Childrens Medical Center Dallas",
      "latitude": 32.80852,
      "longitude": -96.836102,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 5377,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 781,
      "INPATIENT_REVENUE": "$8,41,49,10,976.00",
      "NET_PATIENT_REVENUE": "$1,35,64,15,488.00",
      "OUTPATIENT_REVENUE": "2506126848",
      "accreditation_count": 11,
      "city": "Dallas",
      "coc_type": null,
      "hosp10_name": "Medical City Dallas",
      "latitude": 32.911387,
      "longitude": -96.77372,
      "prov_control_type": "Proprietary - Corporation",
      "provider_number": 3914,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 648,
      "INPATIENT_REVENUE": "$3,99,53,72,544.00",
      "NET_PATIENT_REVENUE": "$1,27,14,63,040.00",
      "OUTPATIENT_REVENUE": "2768288512",
      "accreditation_count": 12,
      "city": "Houston",
      "coc_type": null,
      "hosp10_name": "CHI St Lukes Health - Baylor St Lukes Medical Center",
      "latitude": 29.707837,
      "longitude": -95.400935,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 4021,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 720,
      "INPATIENT_REVENUE": "$3,05,27,92,576.00",
      "NET_PATIENT_REVENUE": "$1,15,92,54,272.00",
      "OUTPATIENT_REVENUE": "1291079168",
      "accreditation_count": 13,
      "city": "Fort Worth",
      "coc_type": null,
      "hosp10_name": "Texas Health Fort Worth (FKA Texas Health Harris Methodist Hospital Fort Worth)",
      "latitude": 38.359959,
      "longitude": 38.359959,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 4148,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 787,
      "INPATIENT_REVENUE": "$3,25,73,77,536.00",
      "NET_PATIENT_REVENUE": "$1,05,43,12,384.00",
      "OUTPATIENT_REVENUE": "5587576832",
      "accreditation_count": 13,
      "city": "Dallas",
      "coc_type": null,
      "hosp10_name": "Parkland Health (FKA Parkland Health and Hospital System)",
      "latitude": 32.812,
      "longitude": -96.836769,
      "prov_control_type": "Governmental - Hospital District",
      "provider_number": 3931,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 235,
      "INPATIENT_REVENUE": "$1,60,70,30,784.00",
      "NET_PATIENT_REVENUE": "$99,24,01,408.00",
      "OUTPATIENT_REVENUE": "2624872192",
      "accreditation_count": 15,
      "city": "Edinburg",
      "coc_type": null,
      "hosp10_name": "Doctors Hospital at Renaissance Health (AKA DHR Health)",
      "latitude": 26.252805,
      "longitude": -98.204995,
      "prov_control_type": "Proprietary - Partnership",
      "provider_number": 4039,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 518,
      "INPATIENT_REVENUE": "$3,22,69,16,864.00",
      "NET_PATIENT_REVENUE": "$98,27,79,904.00",
      "OUTPATIENT_REVENUE": "4804399104",
      "accreditation_count": 16,
      "city": "Tyler",
      "coc_type": null,
      "hosp10_name": "CHRISTUS Mother Frances Hospital - Tyler",
      "latitude": 32.342624,
      "longitude": -95.291902,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 4127,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 584,
      "INPATIENT_REVENUE": "$6,38,90,62,144.00",
      "NET_PATIENT_REVENUE": "$93,59,53,664.00",
      "OUTPATIENT_REVENUE": "2112684544",
      "accreditation_count": 9,
      "city": "Plano",
      "coc_type": null,
      "hosp10_name": "Medical City Plano (FKA Medical Center of Plano)",
      "latitude": 33.020434,
      "longitude": -96.766412,
      "prov_control_type": "Proprietary - Partnership",
      "provider_number": 3898,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 350,
      "INPATIENT_REVENUE": "$4,09,47,49,184.00",
      "NET_PATIENT_REVENUE": "$92,26,65,536.00",
      "OUTPATIENT_REVENUE": "2843601408",
      "accreditation_count": 6,
      "city": "Austin",
      "coc_type": null,
      "hosp10_name": "St Davids Medical Center",
      "latitude": 30.290681,
      "longitude": -97.726745,
      "prov_control_type": "Proprietary - Partnership",
      "provider_number": 4158,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 444,
      "INPATIENT_REVENUE": "$1,17,79,05,792.00",
      "NET_PATIENT_REVENUE": "$75,36,34,944.00",
      "OUTPATIENT_REVENUE": "1841932544",
      "accreditation_count": 13,
      "city": "Houston",
      "coc_type": null,
      "hosp10_name": "Ben Taub Hospital",
      "latitude": 29.7106568,
      "longitude": -95.3938298,
      "prov_control_type": "Governmental - Hospital District",
      "provider_number": 274186,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 576,
      "INPATIENT_REVENUE": "$1,77,46,89,024.00",
      "NET_PATIENT_REVENUE": "$73,77,28,640.00",
      "OUTPATIENT_REVENUE": "840757376",
      "accreditation_count": 10,
      "city": "Dallas",
      "coc_type": null,
      "hosp10_name": "Texas Health Dallas (FKA Texas Health Presbyterian Hospital Dallas)",
      "latitude": 32.881279,
      "longitude": -96.76223,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 3928,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 599,
      "INPATIENT_REVENUE": "$2,79,81,48,608.00",
      "NET_PATIENT_REVENUE": "$70,98,62,848.00",
      "OUTPATIENT_REVENUE": "2919670784",
      "accreditation_count": 4,
      "city": "Abilene",
      "coc_type": null,
      "hosp10_name": "Hendrick Medical Center",
      "latitude": 32.472171,
      "longitude": -99.733822,
      "prov_control_type": "Voluntary Nonprofit - Church",
      "provider_number": 4153,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 391,
      "INPATIENT_REVENUE": "$2,50,54,56,384.00",
      "NET_PATIENT_REVENUE": "$70,25,24,800.00",
      "OUTPATIENT_REVENUE": "1389933696",
      "accreditation_count": 10,
      "city": "Austin",
      "coc_type": null,
      "hosp10_name": "Ascension Seton Medical Center Austin",
      "latitude": 30.304914,
      "longitude": -97.745402,
      "prov_control_type": "Voluntary Nonprofit - Church",
      "provider_number": 4159,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 350,
      "INPATIENT_REVENUE": "$2,44,32,82,944.00",
      "NET_PATIENT_REVENUE": "$66,91,15,776.00",
      "OUTPATIENT_REVENUE": "2012978816",
      "accreditation_count": 7,
      "city": "Austin",
      "coc_type": null,
      "hosp10_name": "St Davids North Austin Medical Center",
      "latitude": 30.383637,
      "longitude": -97.708233,
      "prov_control_type": "Proprietary - Corporation",
      "provider_number": 4165,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 307,
      "INPATIENT_REVENUE": "$1,12,23,76,704.00",
      "NET_PATIENT_REVENUE": "$54,72,30,656.00",
      "OUTPATIENT_REVENUE": "618246336",
      "accreditation_count": 9,
      "city": "Plano",
      "coc_type": null,
      "hosp10_name": "Texas Health Plano (FKA Texas Health Presbyterian Hospital Plano)",
      "latitude": 33.043606,
      "longitude": -96.836702,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 3899,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 451,
      "INPATIENT_REVENUE": "$1,24,83,81,056.00",
      "NET_PATIENT_REVENUE": "$53,08,05,248.00",
      "OUTPATIENT_REVENUE": "625588480",
      "accreditation_count": 8,
      "city": "Fort Worth",
      "coc_type": null,
      "hosp10_name": "Baylor Scott & White All Saints Medical Center - Fort Worth",
      "latitude": 32.729334,
      "longitude": -97.345545,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 4149,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 344,
      "INPATIENT_REVENUE": "$2,74,91,02,336.00",
      "NET_PATIENT_REVENUE": "$52,82,52,384.00",
      "OUTPATIENT_REVENUE": "1827441024",
      "accreditation_count": 7,
      "city": "Austin",
      "coc_type": null,
      "hosp10_name": "St Davids South Austin Medical Center",
      "latitude": 30.227468,
      "longitude": -97.773479,
      "prov_control_type": "Proprietary - Partnership",
      "provider_number": 4167,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 243,
      "INPATIENT_REVENUE": "$75,89,03,104.00",
      "NET_PATIENT_REVENUE": "$38,77,04,256.00",
      "OUTPATIENT_REVENUE": "695599232",
      "accreditation_count": 5,
      "city": "Fort Worth",
      "coc_type": null,
      "hosp10_name": "Texas Health Southwest Fort Worth (FKA Texas Health Harris Methodist Hospital Southwest Fort Worth)",
      "latitude": 32.657808,
      "longitude": -97.420746,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 4139,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 192,
      "INPATIENT_REVENUE": "$73,98,60,416.00",
      "NET_PATIENT_REVENUE": "$33,45,05,920.00",
      "OUTPATIENT_REVENUE": "565729984",
      "accreditation_count": 7,
      "city": "Arlington",
      "coc_type": null,
      "hosp10_name": "Texas Health Arlington Memorial",
      "latitude": 32.7501336,
      "longitude": -97.116288,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 4146,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 195,
      "INPATIENT_REVENUE": "$72,65,76,000.00",
      "NET_PATIENT_REVENUE": "$31,77,68,032.00",
      "OUTPATIENT_REVENUE": "486406176",
      "accreditation_count": 5,
      "city": "Bedford",
      "coc_type": null,
      "hosp10_name": "Texas Health HEB (FKA Texas Health Harris Methodist Hospital HEB)",
      "latitude": 32.834634,
      "longitude": -97.12367,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 4134,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 225,
      "INPATIENT_REVENUE": "$64,67,60,256.00",
      "NET_PATIENT_REVENUE": "$29,74,68,416.00",
      "OUTPATIENT_REVENUE": "714950656",
      "accreditation_count": 4,
      "city": "Waco",
      "coc_type": null,
      "hosp10_name": "Ascension Providence",
      "latitude": 31.514261,
      "longitude": -97.199131,
      "prov_control_type": "Voluntary Nonprofit - Church",
      "provider_number": 4082,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 217,
      "INPATIENT_REVENUE": "$63,38,12,480.00",
      "NET_PATIENT_REVENUE": "$29,13,98,208.00",
      "OUTPATIENT_REVENUE": "476693760",
      "accreditation_count": 4,
      "city": "Denton",
      "coc_type": null,
      "hosp10_name": "Texas Health Denton (FKA Texas Health Presbyterian Hospital Denton)",
      "latitude": 30.2884839,
      "longitude": -97.7244107,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 3941,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 152,
      "INPATIENT_REVENUE": "$48,46,83,328.00",
      "NET_PATIENT_REVENUE": "$25,92,64,304.00",
      "OUTPATIENT_REVENUE": "428353664",
      "accreditation_count": 4,
      "city": "Plano",
      "coc_type": null,
      "hosp10_name": "Baylor Scott & White Medical Center - Plano",
      "latitude": 33.013861,
      "longitude": -96.790659,
      "prov_control_type": "Voluntary Nonprofit - Church",
      "provider_number": 3893,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 99,
      "INPATIENT_REVENUE": "$28,71,36,256.00",
      "NET_PATIENT_REVENUE": "$23,46,24,464.00",
      "OUTPATIENT_REVENUE": "384753344",
      "accreditation_count": 2,
      "city": "Flower Mound",
      "coc_type": null,
      "hosp10_name": "Texas Health Flower Mound (FKA Texas Health Presbyterian Hospital Flower Mound)",
      "latitude": 33.0456562,
      "longitude": -97.0675146,
      "prov_control_type": "Proprietary - Corporation",
      "provider_number": 274291,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 63,
      "INPATIENT_REVENUE": "$22,42,00,832.00",
      "NET_PATIENT_REVENUE": "$16,78,20,848.00",
      "OUTPATIENT_REVENUE": "334682272",
      "accreditation_count": 3,
      "city": "Frisco",
      "coc_type": null,
      "hosp10_name": "Texas Health Frisco",
      "latitude": 33.1813856,
      "longitude": -96.8371099,
      "prov_control_type": "Proprietary - Partnership",
      "provider_number": 948572,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 59,
      "INPATIENT_REVENUE": "$17,48,32,000.00",
      "NET_PATIENT_REVENUE": "$13,54,12,128.00",
      "OUTPATIENT_REVENUE": "275791456",
      "accreditation_count": 5,
      "city": "Allen",
      "coc_type": null,
      "hosp10_name": "Texas Health Allen (FKA Texas Health Presbyterian Hospital Allen)",
      "latitude": 33.116305,
      "longitude": -96.673218,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 3897,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 53,
      "INPATIENT_REVENUE": "$17,73,81,104.00",
      "NET_PATIENT_REVENUE": "$13,08,33,880.00",
      "OUTPATIENT_REVENUE": "345561952",
      "accreditation_count": 1,
      "city": "Rockwall",
      "coc_type": null,
      "hosp10_name": "Texas Health Rockwall",
      "latitude": 32.884828,
      "longitude": -96.465914,
      "prov_control_type": "Proprietary - Corporation",
      "provider_number": 4119,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 34,
      "INPATIENT_REVENUE": "$3,75,28,988.00",
      "NET_PATIENT_REVENUE": "$6,30,64,352.00",
      "OUTPATIENT_REVENUE": "180214368",
      "accreditation_count": 2,
      "city": "Arlington",
      "coc_type": null,
      "hosp10_name": "USMD Hospital at Arlington",
      "latitude": 32.679863,
      "longitude": -97.1174713,
      "prov_control_type": "Proprietary - Partnership",
      "provider_number": 4140,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": null,
      "INPATIENT_REVENUE": null,
      "NET_PATIENT_REVENUE": null,
      "OUTPATIENT_REVENUE": null,
      "accreditation_count": 6,
      "city": "Galveston",
      "coc_type": null,
      "hosp10_name": "UTMB - Texas Department of Criminal Justice Hospital",
      "latitude": 29.311085,
      "longitude": -94.778125,
      "prov_control_type": null,
      "provider_number": 1047339,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": null,
      "INPATIENT_REVENUE": null,
      "NET_PATIENT_REVENUE": null,
      "OUTPATIENT_REVENUE": null,
      "accreditation_count": 1,
      "city": "Edinburg",
      "coc_type": null,
      "hosp10_name": "DHR Health Behavioral Hospital",
      "latitude": 26.253214,
      "longitude": -98.201124,
      "prov_control_type": "Proprietary - Partnership",
      "provider_number": 841664,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": null,
      "INPATIENT_REVENUE": null,
      "NET_PATIENT_REVENUE": null,
      "OUTPATIENT_REVENUE": null,
      "accreditation_count": 0,
      "city": "Bellaire",
      "coc_type": null,
      "hosp10_name": "Houston Thyroid and Endocrine Specialists",
      "latitude": 29.705288,
      "longitude": -95.46182,
      "prov_control_type": null,
      "provider_number": 646413,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": null,
      "INPATIENT_REVENUE": null,
      "NET_PATIENT_REVENUE": null,
      "OUTPATIENT_REVENUE": null,
      "accreditation_count": 0,
      "city": "San Antonio",
      "coc_type": null,
      "hosp10_name": "South Texas Radiology Imaging Centers",
      "latitude": 29.5136309,
      "longitude": -98.5766186,
      "prov_control_type": null,
      "provider_number": 595227,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": null,
      "INPATIENT_REVENUE": null,
      "NET_PATIENT_REVENUE": null,
      "OUTPATIENT_REVENUE": null,
      "accreditation_count": 0,
      "city": "Fort Worth",
      "coc_type": null,
      "hosp10_name": "Radiology Associates of North Texas PA",
      "latitude": 32.737547,
      "longitude": -97.333759,
      "prov_control_type": null,
      "provider_number": 585301,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": null,
      "INPATIENT_REVENUE": null,
      "NET_PATIENT_REVENUE": null,
      "OUTPATIENT_REVENUE": null,
      "accreditation_count": 0,
      "city": "San Antonio",
      "coc_type": null,
      "hosp10_name": "Methodist Ambulatory Surgery Center - Medical Center",
      "latitude": 29.51031,
      "longitude": -98.572073,
      "prov_control_type": null,
      "provider_number": 559626,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": null,
      "INPATIENT_REVENUE": null,
      "NET_PATIENT_REVENUE": null,
      "OUTPATIENT_REVENUE": null,
      "accreditation_count": 0,
      "city": "Dallas",
      "coc_type": null,
      "hosp10_name": "Texas Oncology",
      "latitude": 32.914488,
      "longitude": -96.772626,
      "prov_control_type": null,
      "provider_number": 553058,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": null,
      "INPATIENT_REVENUE": null,
      "NET_PATIENT_REVENUE": null,
      "OUTPATIENT_REVENUE": null,
      "accreditation_count": 0,
      "city": "Austin",
      "coc_type": null,
      "hosp10_name": "Austin Regional Clinic PA",
      "latitude": 30.4463436,
      "longitude": -97.8057513,
      "prov_control_type": null,
      "provider_number": 550726,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": null,
      "INPATIENT_REVENUE": null,
      "NET_PATIENT_REVENUE": null,
      "OUTPATIENT_REVENUE": null,
      "accreditation_count": 0,
      "city": "Houston",
      "coc_type": null,
      "hosp10_name": "Kelsey-Seybold Clinic",
      "latitude": 29.705322,
      "longitude": -95.421677,
      "prov_control_type": null,
      "provider_number": 550391,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 106,
      "INPATIENT_REVENUE": null,
      "NET_PATIENT_REVENUE": null,
      "OUTPATIENT_REVENUE": null,
      "accreditation_count": 0,
      "city": "Houston",
      "coc_type": null,
      "hosp10_name": "Texas Childrens Pavilion for Women",
      "latitude": 29.708158,
      "longitude": -95.402791,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 550180,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": null,
      "INPATIENT_REVENUE": null,
      "NET_PATIENT_REVENUE": null,
      "OUTPATIENT_REVENUE": null,
      "accreditation_count": 1,
      "city": "Waco",
      "coc_type": null,
      "hosp10_name": "The Providence Heart Hospital at Ascension Providence (Closed)",
      "latitude": 31.514261,
      "longitude": -97.199131,
      "prov_control_type": "Voluntary Nonprofit - Church",
      "provider_number": 274331,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": null,
      "INPATIENT_REVENUE": null,
      "NET_PATIENT_REVENUE": null,
      "OUTPATIENT_REVENUE": null,
      "accreditation_count": 6,
      "city": "Longview",
      "coc_type": null,
      "hosp10_name": "CHRISTUS Good Shepherd Medical Center - Longview",
      "latitude": 32.5008276,
      "longitude": -94.7304434,
      "prov_control_type": "Voluntary Nonprofit - Church",
      "provider_number": 3982,
      "state": "TX"
  },
  {
      "CALC_MEDICAID_GROSS_REVENUE": null,
      "CALC_STATS_ADJ_PT_DISCHARGE": null,
      "CALC_STATS_BEDS_TOTAL": 238,
      "INPATIENT_REVENUE": null,
      "NET_PATIENT_REVENUE": null,
      "OUTPATIENT_REVENUE": null,
      "accreditation_count": 7,
      "city": "Houston",
      "coc_type": null,
      "hosp10_name": "Memorial Hermann Greater Heights Hospital (FKA Memorial Hermann Northwest Hospital)",
      "latitude": 29.811503,
      "longitude": -95.4309,
      "prov_control_type": "Voluntary Nonprofit - Other",
      "provider_number": 4020,
      "state": "TX"
  }
];